/**
 * @generated SignedSource<<a26dd6821f66dddd0d9fbf2ac1c7d6c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgStoreAdminCopyStoreMutation$variables = {
  storeId: string;
  workspaceId: string;
};
export type OrgStoreAdminCopyStoreMutation$data = {
  readonly workspace: {
    readonly copyStoreStructure: {
      readonly storeId: string;
      readonly workspace: {
        readonly stores: ReadonlyArray<{
          readonly id: string;
        }>;
      };
    } | null;
  };
};
export type OrgStoreAdminCopyStoreMutation = {
  response: OrgStoreAdminCopyStoreMutation$data;
  variables: OrgStoreAdminCopyStoreMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "storeId",
    "variableName": "storeId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "storeId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "stores",
  "plural": true,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgStoreAdminCopyStoreMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "WorkspaceMutation",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "CopyStoreStructurePayload",
            "kind": "LinkedField",
            "name": "copyStoreStructure",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgStoreAdminCopyStoreMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "WorkspaceMutation",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "CopyStoreStructurePayload",
            "kind": "LinkedField",
            "name": "copyStoreStructure",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c2b7957362bd8bb11a0bcd5c8e4f674b",
    "id": null,
    "metadata": {},
    "name": "OrgStoreAdminCopyStoreMutation",
    "operationKind": "mutation",
    "text": "mutation OrgStoreAdminCopyStoreMutation(\n  $workspaceId: ID!\n  $storeId: ID!\n) {\n  workspace(id: $workspaceId) {\n    copyStoreStructure(storeId: $storeId) {\n      storeId\n      workspace {\n        stores {\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd605b82a7e51f7490bfc90737852dc6";

export default node;
